import { Directive, Input, ElementRef, HostListener, OnDestroy, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef, ConnectionPositionPair, } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { TooltipComponent } from './tooltip.component';

@Directive({
  selector: '[appTooltip]',
  standalone: true
})
export class TooltipDirective implements OnDestroy {
  @Input('appTooltip') tooltipText = '';

  private overlayRef: OverlayRef | null = null;

  constructor(
    private elementRef: ElementRef,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef
  ) { }

  @HostListener('mouseenter')
  showTooltip(): void {
    if (!this.tooltipText) {
      return;
    }

    // Estratégia de posicionamento conectada ao elemento host
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        // 1) Abaixo, alinhado à esquerda
        new ConnectionPositionPair(
          { originX: 'start', originY: 'bottom' },
          { overlayX: 'start', overlayY: 'top' }
        ),
        // 2) Acima, alinhado à esquerda
        new ConnectionPositionPair(
          { originX: 'start', originY: 'top' },
          { overlayX: 'start', overlayY: 'bottom' }
        ),
        // 3) À direita, central
        new ConnectionPositionPair(
          { originX: 'end', originY: 'center' },
          { overlayX: 'start', overlayY: 'center' }
        ),
        // 4) À esquerda, central
        new ConnectionPositionPair(
          { originX: 'start', originY: 'center' },
          { overlayX: 'end', overlayY: 'center' }
        ),
      ])
      .withFlexibleDimensions(false)
      .withPush(false);

    this.overlayRef = this.overlay.create({ positionStrategy });

    const tooltipPortal = new ComponentPortal(TooltipComponent, this.viewContainerRef);
    const tooltipRef = this.overlayRef.attach(tooltipPortal);
    tooltipRef.instance.text = this.tooltipText;
  }

  @HostListener('mouseleave')
  hideTooltip(): void {
    this.closeTooltip();
  }

  private closeTooltip(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }

  ngOnDestroy(): void {
    this.closeTooltip();
  }
}